import { AgmMap } from '@agm/core';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { mapStyles } from 'src/app/utils/utils.common';
import { ZonesService } from '../zones-service/zones.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-zones',
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.css']
})
export class ZonesComponent implements OnInit, AfterViewInit {
  zoneForm!: FormGroup;
  @ViewChild("agmMap", { static: true }) agmElement: AgmMap;

  agmMap;
  origin = { lat: 32.7157, lng: 117.1611 };
  styles = mapStyles();
  search;
  zones;
  selectedZone;

  queryStatus='';
  selectedId:any='';
  polygon: any;
  selectedPath = [];
  isSaving = false;

  managerOptions = {
    drawingControl: true,
    drawingControlOptions: {
      drawingModes: ['polygon'],
    },
    polygonOptions: {
      draggable: true,
      editable: true,
    },
    drawingMode: 'polygon',
  };

  options: any = {
    lat: 33.5362475,
    lng: -111.9267386,
    zoom: 10,
    fillColor: '#DC143C',
    draggable: true,
    editable: true,
    visible: true,
  };

  constructor(private zonesService: ZonesService, private sharedDataService: SharedDataService, private toastr: ToastrService, private fb: FormBuilder) { }

  ngOnInit() {
    this.getZones();
     this.zoneForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3),Validators.pattern(/\S+/) ]],
      status: ['active', Validators.required],
      color: ['#000000', Validators.required]
    });
  }
 get f() {
    return this.zoneForm.controls;
  }
  ngAfterViewInit() {
    // console.log(this.agmElement);
    this.agmElement.mapReady.subscribe((map) => {
      this.agmMap = map;
    });
  }

  getZones() {
    let queryParams: any = {}
    if (this.queryStatus !== '') {
      queryParams.status = this.queryStatus
    }

    this.zonesService.getZones(queryParams).subscribe(data => {
      this.zones = data;
    })

  }

  polygonCreated($event) {
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = $event;
    this.addPolygonChangeEvent(this.polygon);
    this.selectedPath=[]
    google.maps.event.addListener(
      this.polygon,
      'coordinates_changed',
      function (index, obj) {
        this.selectedPath=[]
          
        // Polygon object: yourPolygon
        console.log('coordinates_changed');
      }
    );
  }

  addPolygonChangeEvent(polygon) {
    var me = polygon,
      isBeingDragged = false,
      triggerCoordinatesChanged = function () {
        // Broadcast normalized event
        google.maps.event.trigger(me, 'coordinates_changed');
      };

    // If  the overlay is being dragged, set_at gets called repeatedly,
    // so either we can debounce that or igore while dragging,
    // ignoring is more efficient
    google.maps.event.addListener(me, 'dragstart', function () {
      isBeingDragged = true;
    });

    // If the overlay is dragged
    google.maps.event.addListener(me, 'dragend', function () {
      triggerCoordinatesChanged();
      isBeingDragged = false;
    });

    // Or vertices are added to any of the possible paths, or deleted
    var paths = me.getPaths();
    paths.forEach(function (path, i) {
      google.maps.event.addListener(path, 'insert_at', function () {
        triggerCoordinatesChanged();
      });
      google.maps.event.addListener(path, 'set_at', function () {
        if (!isBeingDragged) {
          triggerCoordinatesChanged();
        }
      });
      google.maps.event.addListener(path, 'remove_at', function () {
        triggerCoordinatesChanged();
      });
    });
  }


  saveZone() {
    if (this.isSaving) return;

    if (this.zoneForm.invalid) {
      this.zoneForm.markAllAsTouched();
      return;
    }

    const name = this.zoneForm.value.name.trim();
    if ((this.zones).some((zone: any) => zone._id !== this.selectedId && zone.name.trim().toLowerCase() === name.toLowerCase())) {
      sweetAlert("Error", "A zone with this name already exists.", "error", "Ok");
      return;
    }


    let coordinates: any = [];

    if (this.polygon && this.polygon.getPaths && this.polygon.getPaths().getLength() > 0) {
      this.polygon.getPaths().forEach((path: any) => {
        path.forEach((point: any) => {
          coordinates.push([point.lng(), point.lat()]);
        });
      });
    } else {
      coordinates =
        this.selectedZone.geo.coordinates.length
          ? this.selectedZone.geo.coordinates[0]
          : [];
    }


    if (!coordinates || coordinates.length < 4) {
      sweetAlert("Error", "At least 4 Coordinates are required", "error", "Ok");
      return

    }



    coordinates.push(coordinates[0]);

    const payload = {
    ...this.zoneForm.value,
     name,
     coordinates: [coordinates],
      
    };

    this.isSaving = true;
    this.zonesService.saveZone(this.selectedId, payload).subscribe({
      next: (res) => {
        this.isSaving = false;
        this.selectedZone = null;
        this.selectedId = '';
        this.selectedPath = [];


        this.zoneForm.reset({
          name: '',
          status: 'active',
          color: '#000000'
        });

        // 🔹 Remove polygon
        if (this.polygon) {
          this.polygon.setMap(null);
          this.polygon = null;
        }

        this.getZones();
      },

      error: (error: any) => {
        this.isSaving = false;
        this.toastr.error(
          error || 'An error occurred while saving the zone.',
          'Error'
        );
      }
    });
  }
  selectZone(zone) {
    this.selectedZone = zone;
    this.polygoneToLitteral();
  }

  polygoneToLitteral() {
    this.selectedPath = [];
    let bounds = new google.maps.LatLngBounds();
    this.selectedZone.geo.coordinates[0].forEach(element => {
      this.selectedPath.push({ lat: element[1], lng: element[0] })

      bounds.extend(
        new google.maps.LatLng(
          element[1], element[0])
      );

    });

    this.agmMap.setCenter(bounds.getCenter());
    this.agmMap.fitBounds(bounds);
  }

  async deleteZone(id) {
    const confirm = await sweetAlert(
      "Alert!",
      `Are you sure you want to delete this zone?`,
      "warning",
      "Yes",
      "No"
    );
    if (confirm.value) {
      this.deleteZoneById(id)
    }
  }

 editZone(item: any) {
  this.selectedId=item._id;
  this.selectedZone = item;
   if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    
    }
    this.zoneForm.patchValue({
      name: item.name,
      status: item.status,
      color: item.color
    });


}
  deleteZoneById(id) {
    this.zonesService.deleteZone(
      id
    ).subscribe(data => {
      console.log(data)
      this.selectedZone = null;
      this.selectedId='';
      this.selectedPath = [];
      this.zoneForm.reset({
        name: '',
        status: 'active',
        color: '#000000'
      });
      if (this.polygon) {
        this.polygon.setMap(null);
        this.polygon = null;
      }
      this.getZones();
    })
  }

  clearMap() {
    if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    
    }
      this.selectedId='';
      this.selectedZone = null;
      this.selectedPath = [];
       this.zoneForm.reset({
        name: '',
        status: 'active',
        color: '#000000'
      });
  }
  clearZone(){
     if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
    
    }
    this.selectedPath=[];
  }
}
